import { Button } from "@/components/ui/button";
import { CreditCard, School } from "lucide-react";

// Parent Dashboard -> "Payments" card. Extracted from ParentDashboard.js
// (props-driven, no behavior change beyond the v1.3 balance summary line).
//
// v1.3 Presentation Mode polish: always show the current balance right at
// the top of this card ($0.00 included) instead of leaving it blank —
// per-student balances further down the page add detail, not the first
// answer to "do we owe anything?".
export const PaymentsCard = ({ balanceTotal, onViewPayments, onBrowseClassrooms }) => (
  <section className="rounded-[var(--radius)] border bg-card p-4 sm:p-5 space-y-3">
    <div className="flex items-center justify-between">
      <h2 className="text-lg font-semibold font-heading flex items-center gap-2">
        <CreditCard className="h-5 w-5 text-[hsl(var(--role-accent))]" /> Payments
      </h2>
      <p
        className={`text-lg font-semibold tabular-nums font-heading ${balanceTotal > 0 ? "text-destructive" : "text-[hsl(var(--status-good))]"}`}
        data-testid="parent-payments-card-balance"
      >
        ${(balanceTotal || 0).toFixed(2)}
      </p>
    </div>
    <Button variant="secondary" className="w-full" onClick={onViewPayments} data-testid="parent-view-payments-button">
      View payment history & receipts
    </Button>
    <Button variant="secondary" className="w-full" onClick={onBrowseClassrooms} data-testid="parent-browse-classrooms-button">
      <School className="h-4 w-4 mr-2" /> Browse Classroom Sessions
    </Button>
  </section>
);
